import { AxiosResponse } from 'axios';
import { IDataWithPagination, TPhoto } from 'common/types';

import {
  IArticle,
  ICreateArticle,
  IArticleParams,
} from './../common/types/article';

import { $host } from './index';

export const getAllArticles = async (params?: IArticleParams) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IDataWithPagination<IArticle>>>(
    'admin/articles',
    {
      params: params ?? {
        page: 1,
        pageSize: 50,
        sort: 'DESC',
        sortBy: 'updatedAt',
      },
    },
  );

  return data;
};

export const getArticleById = async (id: IArticle['id']) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IArticle>>(`admin/articles/${id}`);

  return data;
};

export const createArticle = async (params: ICreateArticle) => {
  const { data } = await $host.post<AxiosResponse<IArticle>>(
    `admin/articles`,
    params,
  );

  return data.data;
};

export const editArticle = async (
  id: IArticle['id'],
  params: ICreateArticle,
) => {
  const { data } = await $host.put<AxiosResponse<IArticle>>(
    `admin/articles/${id}`,
    params,
  );

  return data.data;
};

export const deleteArticle = async (id: IArticle['id']) => {
  const { data } = await $host.delete<AxiosResponse<IArticle>>(
    `admin/articles/${id}`,
  );

  return data.data;
};

export const uploadMarkdownImage = async (image: FormData) => {
  const { data } = await $host.post<AxiosResponse<TPhoto>>(`upload`, image, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data;
};
